import React from 'react';
import '../App.css'
import Card from './card';
import {Link} from "react-router-dom";
class home extends React.Component{

    render(){
        return(
            <div className="Home-main">
                <header className="Home-header">
                    <PlayerForm></PlayerForm>
                </header>
                <div className="box">
                    <h6>Or click on any of the proffesional players down below</h6>
                </div>
                <div className="container card-group">
                    <div className="row">
                        <div className="col-md-6 flex-justify-center">
                            <Link to="/id/70388657"><Card playerId={70388657}/></Link><br/>
                            <Link to="id/105248644"><Card playerId={105248644}/></Link><br/>
                        </div>
                        <div className="col-md-6 flex-justify-center">
                            <Link to="/id/86745912"><Card playerId={86745912}/></Link><br/>
                            <Link to="/id/92423451"><Card playerId={92423451}/></Link><br/>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}
export default home;

class PlayerForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {value: ''};
    
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({value: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();

        alert('Havent finished this module yet ');
        event.preventDefault();
    }

    render(){
        return(
            <form  onSubmit={this.handleSubmit}>
                <input className="search-box" value={this.state.value} onChange={this.handleChange} placeholder="Steam Username" />
            </form>
        );
    }
}
